import DeliveryType from './DeliveryType'
import PaymentMode from './PaymentMode'

export default class PaymentType {
  static get Cash () { return 'cash' }
  static get Terminal () { return 'terminal' }
  static get Online () { return 'online' }
  static get AggregatorOnline () { return 'aggregator_online' }

  // «курьеру» - только если деньги берёт курьер: доставка в режиме оплаты курьеру
  // (режим null - заказ не из CRM или старый, для доставки это тот же курьер)
  static isPaidToCourier (deliveryType, paymentMode = null) {
    return !!deliveryType &&
      deliveryType !== DeliveryType.Self &&
      (!paymentMode || paymentMode === PaymentMode.Courier)
  }

  static getName (enumValue, deliveryType, paymentMode = null) {
    const byCourier = PaymentType.isPaidToCourier(deliveryType, paymentMode)

    switch (enumValue) {
      case PaymentType.Terminal:
        return byCourier ? 'Картой курьеру' : 'Картой'

      case PaymentType.Cash:
        return byCourier ? 'Наличными курьеру' : 'Наличными'

      case PaymentType.Online:
        return 'Онлайн'

      case PaymentType.AggregatorOnline:
        return 'Онлайн в агрегаторе'

      default:
        return enumValue
    }
  }

  // для истории: где взяли деньги - «картой на кассе» / «наличными курьеру»
  static getNameWithPlace (enumValue, deliveryType, paymentMode = null) {
    const name = PaymentType.getName(enumValue, deliveryType, paymentMode)
    const atCashDesk = [PaymentType.Terminal, PaymentType.Cash].includes(enumValue) &&
      !PaymentType.isPaidToCourier(deliveryType, paymentMode)

    return atCashDesk ? `${name} на кассе` : name
  }

  // подпись кнопки в окне выбора типа: без «курьеру» - клиент может платить и на точке
  static getPickLabel (enumValue, deliveryType) {
    switch (enumValue) {
      case PaymentType.Terminal:
        return PaymentType.getName(enumValue, deliveryType, PaymentMode.PayNow)

      case PaymentType.Cash:
        return 'Наличными'

      default:
        return PaymentType.getName(enumValue, deliveryType)
    }
  }
}
